import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.16634 0.5C6.04925 0.5 4.33301 2.21624 4.33301 4.33333C4.33301 6.45043 6.04925 8.16667 8.16634 8.16667H11.9997V0.5H8.16634Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.16634 8.16667C6.04925 8.16667 4.33301 9.88308 4.33301 12.0002C4.33301 14.1009 6.02278 15.8069 8.11725 15.8332C6.02582 15.8419 4.33301 17.5731 4.33301 19.6665C4.33301 21.7652 6.06766 23.4998 8.16634 23.4998C10.265 23.4998 11.9997 21.7985 11.9997 19.6998V8.16667H8.16634Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.667 4.33333C19.667 2.21624 17.9507 0.5 15.8337 0.5H11.9997V8.16667H15.8337C17.9507 8.16667 19.667 6.45043 19.667 4.33333Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.667 12.0005C19.667 9.88331 17.9508 8.16667 15.8337 8.16667C13.7165 8.16667 12 9.88331 12 12.0005C12 14.1177 13.7163 15.834 15.8335 15.834C17.9507 15.834 19.667 14.1177 19.667 12.0005Z"}}]};

const LogoFigmaFilled = Vue.extend<IconProps>({
  name: 'LogoFigmaFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-figma-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoFigmaFilled;
